export enum HomeownerInfoSections {
  ownerDocuments = 'owner-documents',
  leaseContracts = 'lease-contracts',
  legalDocuments = 'legal-documents',
  touchpoints = 'touchpoints',
}
